var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendtoBank1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1719 52.7773H13.8281C6.2033 52.7773 0 46.574 0 38.9492V20.0508C0 12.426 6.2033 6.22266 13.8281 6.22266H45.1719C52.7967 6.22266 59 12.426 59 20.0508V38.9492C59 46.574 52.7967 52.7773 45.1719 52.7773ZM13.8281 10.832C8.74491 10.832 4.60938 14.9676 4.60938 20.0508V38.9492C4.60938 44.0324 8.74491 48.168 13.8281 48.168H45.1719C50.2551 48.168 54.3906 44.0324 54.3906 38.9492V20.0508C54.3906 14.9676 50.2551 10.832 45.1719 10.832H13.8281ZM37.9451 33.58L49.3366 24.8784C50.3481 24.1058 50.5417 22.6595 49.769 21.6479C48.9963 20.6364 47.5501 20.4428 46.5386 21.2155L35.1484 29.916C31.8595 32.4245 27.2664 32.4264 23.9753 29.9223L12.9381 21.3426C11.9331 20.5613 10.4851 20.7428 9.704 21.7477C8.92283 22.7527 9.10421 24.2006 10.1092 24.9818L21.155 33.5681C21.1605 33.5725 21.1661 33.5768 21.1718 33.581C23.6406 35.464 26.5986 36.4053 29.5574 36.4053C32.5161 36.4053 35.4755 35.4634 37.9451 33.58Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendtoBank1);
export default __webpack_public_path__ + "static/media/Send to Bank (1).e59ff42b57a36e8d42251b24e19e3db3.svg";
export { ForwardRef as ReactComponent };